import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=edb87ada&scoped=true&"
import script from "./ErrorView.vue?vue&type=script&lang=js&"
export * from "./ErrorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb87ada",
  null
  
)

export default component.exports